export const LogoMark = ({ className = "w-9 h-9", light = false }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path d="M14 58V28a18 18 0 0 1 36 0v30" fill="none" stroke="#B8945A" strokeWidth="1.6" />
    <path d="M26 24h9M30.5 24v22h11" fill="none" stroke={light ? "#F6F0E8" : "#22150E"} strokeWidth="2.6" strokeLinecap="square" />
    <path d="M47 6l1.3 3.4L51.7 11l-3.4 1.3L47 15.7l-1.3-3.4L42.3 11l3.4-1.6z" fill="#B8945A" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark light={light} />
    <span className="leading-none">
      <span className={`block font-display text-[1.35rem] tracking-tight ${light ? "text-cream" : "text-espresso"}`}>
        Lise’s Sugar Studio
      </span>
      <span className={`block text-[10px] uppercase tracking-[0.32em] mt-1 ${light ? "text-[#CDBBA8]" : "text-mocha"}`}>
        Clifton Heights · PA
      </span>
    </span>
  </span>
);
